import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@paypalcorp/pp-react-links';

export class ConfirmationReturnTo extends Component {
  render() {
    return (
      <div className="text-center">
        <Link onClick={this.props.handleRedirect} className="pp_guest_btn">
          {this.props.returnto}
        </Link>
      </div>
    );
  }
}

export default ConfirmationReturnTo;

ConfirmationReturnTo.propTypes = {
  returnto: PropTypes.string,
  handleRedirect: PropTypes.func,
};
